module.exports = __webpack_public_path__ + "pc-top-assets/img/logo.02695bac.svg";